import React from 'react';

import { handleAccessibilityAnchorsFocus } from 'helpers/a11yUtils';
import css from 'styles/components/common/skiplinks.scss';

const SkipLinks = ({ links }) => {
  if (links) {
    return (
      <div className={css.ariaSkipLinksContainer}>
        {Object.keys(links).map(e => {
          if (links[e]) {
            return <a key={e} onClick={handleAccessibilityAnchorsFocus} href={`#${e}`}>{links[e]}</a>;
          }
        })}
      </div>
    );
  }
  return null;
};

export default SkipLinks;
